
export const popCommand = () => ({ type: 'COMMAND_POP' });

export const onToggleAutoplay = () => ({ type: 'TOGGLE_AUTOPLAY' });

export const onNext = () => ({ type: 'COMMAND', payload: 'RIGHT' });

export const onPrev = () => ({ type: 'COMMAND', payload: 'LEFT' });

export const onCommand = cmd => ({ type: 'COMMAND', payload: cmd });

export const onNop = () => ({ type: 'NOP' });

export const remoteAction = action => ({ type: 'REMOTE_ACTION', payload: action });

export const setSession = sessionId => ({ type: 'SET_SESSION_ID', payload: sessionId });



// WEBPACK FOOTER //
// ./src/redux/actions/commandActions.js